import * as Api from '../api/Api';
import createAxios from '../api/WiseOwl';

export function getFeatures() {
    return createAxios().get(Api.PATH_FEATURES);
};

export const removeFeature = (id) => {
    return createAxios().delete(Api.PATH_FEATURES + "/" + id);
}

export const createFeature = (values) => {
    return createAxios().post(Api.PATH_FEATURES, values);
};

export const updateFeature = (id, values) => {
    return createAxios().put(`${Api.PATH_FEATURES}/${id}`, values);
};
